import React, { useEffect } from 'react';
import './StatisticsView.css';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getStatistics } from '../actions/appAction';

const TOTAL_PAGES = 604;

const StatisticsView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { statistics, error, loading } = useSelector((state) => state.app);

  useEffect(() => {
    dispatch(getStatistics());
  }, [dispatch]);

  // if (loading) {
  //   return <div className="statistics-view">Loading...</div>;
  // }

  // if (error) {
  //   return <div className="statistics-view">Error: {error}</div>;
  // }

  // Stats
  const memorized_pages_count = statistics?.memorized_pages_count || 0;
  const under_review_pages_count = statistics?.under_review_pages_count || 0;

  // Overall circle progress
  const overallPercentage = Math.round((memorized_pages_count / TOTAL_PAGES) * 100);

  // Bar progress
  const underReviewPercentage = Math.round((under_review_pages_count / TOTAL_PAGES) * 100);
  const savedPercentage = overallPercentage;

  // For the arc calculations
  const size = 180;                   // matches .circle-container in CSS
  const strokeWidth = 15;
  const center = size / 2;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (overallPercentage / 100) * circumference;

  return (
    <div className="statistics-view" onClick={() => navigate('/review-summary')}>
      <div className="circle-container">
        <svg
          className="progress-svg"
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
        >
          <circle
            className="circle-bg"
            cx={center}
            cy={center}
            r={radius}
            strokeWidth={strokeWidth}
          />
          <circle
            className="circle-progress"
            cx={center}
            cy={center}
            r={radius}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
          />
        </svg>
        <div className="circle-text">
          <p className="progress-percentage">{overallPercentage}%</p>
          <p className="progress-label">المحفوظ</p>
        </div>
      </div>

      <div className="bottom-info">
        <div className="info-section">
          <p className="info-text">
            تحت المراجعة {under_review_pages_count}/{TOTAL_PAGES}
          </p>
          <div className="progress-bar">
            <div
              className="progress-bar-fill"
              style={{ width: `${underReviewPercentage}%` }}
            />
          </div>
        </div>

        <div className="info-section">
          <p className="info-text">
            المحفوظ {memorized_pages_count}/{TOTAL_PAGES}
          </p>
          <div className="progress-bar">
            <div
              className="progress-bar-fill"
              style={{ width: `${savedPercentage}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsView;